/* AUTO GRIJA – product page: kit selector, multi-add, reels */
(() => {
  const root = document.querySelector('[data-pdp]');
  if (!root) return;
  const AG = window.AG || {};
  const form = root.querySelector('form[data-pdp-form]');
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  let product = {};
  try { product = JSON.parse($('[data-product-json]', root).textContent); } catch (e) {}

  const fmt = (cents) => {
    const f = AG.moneyFormat || '{{amount}} lei';
    const n = (cents / 100).toFixed(2).split('.');
    const grp = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_with_comma_separator') return grp(n[0], '.') + ',' + n[1];
      if (k === 'amount_no_decimals') return grp(String(Math.round(cents / 100)), ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(String(Math.round(cents / 100)), '.');
      return grp(n[0], ',') + '.' + n[1];
    });
  };

  const offer = () => { const r = $('input[name="ag-offer"]:checked', root); return r ? r.value : 'single'; };
  const qty = () => Math.max(1, parseInt(($('[data-qty] input', root) || {}).value, 10) || 1);
  const variant = () => {
    const id = +($('[data-variant-id]', root) || {}).value;
    return (product.variants || []).find((v) => v.id === id) || (product.variants || [])[0] || { price: 0 };
  };
  const kitItems = (k) => $$(`[data-kit-item][data-kit="${k}"]`, root);
  const kitSum = (k) => kitItems(k).reduce((a, el) => a + (+el.dataset.price || 0), 0);
  const labelOf = (k) => {
    if (k === 'single') return 'Adaugă în coș';
    const card = $(`input[name="ag-offer"][value="${k}"]`, root);
    const t = card ? $('.ag-offer__top b', card.closest('label')).textContent.trim() : 'kitul';
    return 'Adaugă ' + t.toLowerCase().replace(/^kit/, 'kitul') + ' în coș';
  };

  function refresh() {
    const v = variant();
    const q = qty();
    const o = offer();
    const single = v.price;
    const total = (single + (o === 'single' ? 0 : kitSum(o))) * q;
    const s = $('[data-offer-price="single"]', root); if (s) s.textContent = fmt(single);
    ['apply', 'complete'].forEach((k) => { const el = $(`[data-offer-price="${k}"]`, root); if (el) el.textContent = fmt(single + kitSum(k)); });
    const lbl = $('[data-add-label]', root);
    if (lbl && v.available !== false) lbl.textContent = labelOf(o) + (o === 'single' && q === 1 ? '' : ' · ' + fmt(total));
    const sp = $('[data-sticky-price]'); if (sp) sp.textContent = fmt(total);
    const sn = $('[data-sticky-name]');
    if (sn) sn.textContent = sn.dataset.base ? sn.dataset.base + (o === 'single' ? '' : ' · ' + ($(`input[name="ag-offer"][value="${o}"]`, root).closest('label').querySelector('.ag-offer__top b').textContent.trim())) : sn.textContent;
    const fp = $('[data-final-price]'); if (fp) fp.textContent = fmt(total);
    const fl = $('[data-final-label]'); if (fl) fl.textContent = labelOf(o);
    const sa = $('[data-sticky-add]'); if (sa) sa.textContent = o === 'single' ? 'Adaugă în coș' : 'Adaugă kitul';
    $$('.ag-offer__card', root).forEach((c) => c.classList.toggle('is-on', c.querySelector('input').checked));
  }
  const sn0 = $('[data-sticky-name]'); if (sn0) sn0.dataset.base = sn0.textContent.trim();

  root.addEventListener('change', () => setTimeout(refresh, 0));
  root.addEventListener('click', (e) => { if (e.target.closest('[data-qty-plus],[data-qty-minus]')) setTimeout(refresh, 0); });
  root.addEventListener('input', (e) => { if (e.target.matches('[data-qty] input')) refresh(); });

  // pick offer from comparison table
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pick-offer]');
    if (b) {
      const r = $(`input[name="ag-offer"][value="${b.dataset.pickOffer}"]`, root);
      if (r) { r.checked = true; refresh(); (r.closest('[data-offer]') || root).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
    if (e.target.closest('[data-pdp-submit]') && form) { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
  });

  // multi-add for kits (runs before the generic ajax handler)
  const toast = (m) => { const t = $('.ag-toast'); if (!t) return; t.textContent = m; t.classList.add('is-show'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-show'), 2400); };
  document.addEventListener('submit', async (e) => {
    if (e.target !== form || offer() === 'single') return;
    e.preventDefault(); e.stopPropagation();
    const q = qty();
    const items = [{ id: variant().id, quantity: q }].concat(kitItems(offer()).map((el) => ({ id: +el.dataset.vid, quantity: q })));
    const btn = $('[data-add-btn]', root); btn && btn.classList.add('is-loading');
    try {
      const res = await fetch((AG.routes && AG.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.description || j.message || 'Eroare');
      toast('Kitul a fost adăugat în coș ✓');
      let o = $('[data-cart-open]');
      if (!o) { o = document.createElement('button'); o.type = 'button'; o.hidden = true; o.setAttribute('data-cart-open', ''); document.body.appendChild(o); }
      o.click();
    } catch (err) { toast(err.message || 'Nu am putut adăuga kitul'); }
    btn && btn.classList.remove('is-loading');
  }, true);

  // gallery video: play when its slide is shown
  const gv = $('.ag-gallery__slide--video video', root);
  if (gv) {
    const sync = () => { const on = gv.closest('.ag-gallery__slide').classList.contains('is-active'); if (on) { gv.preload = 'auto'; gv.play().catch(() => {}); } else gv.pause(); };
    new MutationObserver(sync).observe(gv.closest('.ag-gallery__slide'), { attributes: true, attributeFilter: ['class'] });
  }

  // reels: autoplay muted when visible, tap for sound
  const reels = $$('[data-reel] video');
  if (reels.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause();
    }), { threshold: 0.45 });
    reels.forEach((v) => io.observe(v));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-reel-sound]');
    if (!b) return;
    const v = b.closest('[data-reel]').querySelector('video');
    reels.forEach((o) => { if (o !== v) { o.muted = true; o.closest('[data-reel]').classList.remove('is-sound'); } });
    v.muted = !v.muted; if (!v.muted) v.play().catch(() => {});
    b.closest('[data-reel]').classList.toggle('is-sound', !v.muted);
    b.setAttribute('aria-label', v.muted ? 'Pornește sunetul' : 'Oprește sunetul');
  });

  refresh();
})();
